import { format } from 'date-fns';

import { timezonesList } from '@/lib/time-zones';

export const formatTimezoneDuration = (
  date: string | number | Date | null,
  userEventTimezone: string,
  formatString = 'dd MMM, HH:mm'
) => {
  if (!date) return null;
  const localStorageTimezone = timezonesList.find((tz) => tz === userEventTimezone);
  const timeZone = localStorageTimezone || Intl.DateTimeFormat().resolvedOptions().timeZone;

  return format(new Date(new Date(date).toLocaleString('en-US', { timeZone })), formatString);
};
